import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { Action } from "models/order-management/action";
import { OrderResponse } from "models/order-management/orderResponse";
import { RejectedAction } from "models/order-management/rejectedAction";
import CompanyResourceSummary from "models/resource-management/company-resource-summary";
import * as moment from "moment-timezone";
import { Subject } from "rxjs/Subject";
import { OrderManagementDataService } from "../../../../providers/order-management-data-service/order-management-data-service";
import { OrderIdAndSignatureRequest } from "../provider-panel";

@Component({
  selector: "reject-selected-orders",
  templateUrl: "reject-selected-orders.html",
})
export class RejectSelectedOrdersPopup {
  providers: CompanyResourceSummary[] = [];
  providerSearchSubject: Subject<string> = new Subject();
  spinner: any = null;
  spinnerCounter: number = 0;
  patientChartId: number = 0;
  order: OrderResponse;
  userDisplayName: string;

  rejectForm: FormGroup;
  medicationName: string;
  orderId: number;
  orderingProviderId: number;
  orders: OrderIdAndSignatureRequest[] = [];
  isMultiple = false;
  orderData = [];
  groupedByPatientName = {};
  orderCounter: number = 0;

  public constructor(
    private fb: FormBuilder,
    public navCtrl: NavController,
    private navParams: NavParams,
    public viewCtrl: ViewController,
    private orderManagementDataService: OrderManagementDataService
  ) {
    this.medicationName = this.navParams.data.name;
    this.orderId = this.navParams.data.orderId;
    this.userDisplayName = this.navParams.data.userDisplayName;
    this.orderingProviderId = this.navParams.data.orderingProviderId;
    this.orders = this.navParams.data.orders;
    this.isMultiple = this.navParams.data.isMultiple;
    this.orderData = this.navParams.data.orderData;
    this.orderCounter = this.navParams.data.orderCounter;
    this.groupedByPatientName = Object.values(this.orderData).reduce(
      (acc, item) => {
        if (!acc[item.patientName]) {
          acc[item.patientName] = [];
        }
        acc[item.patientName].push(item);
        return acc;
      },
      {}
    );

    this.rejectForm = new FormGroup({
      discontinueDate: this.fb.control(
        moment().format("MM/DD/YYYY"),
        Validators.required
      ),
      reason: this.fb.control("", Validators.required),
    });
  }

  objectKeys(obj) {
    return Object.keys(obj);
  }

  ngOnDestroy(): void {}

  save(): void {
    this.viewCtrl.dismiss({
      bulkUpdateOrderRequest: this.orderManagementDataService.bulkUpdateOrders(
        this.orders.map((order) => {
          const action: RejectedAction = {
            actionType: Action.ActionTypeEnum.Rejected,
            displayName: this.userDisplayName,
            timezone: moment.tz.guess(),
            reason: this.rejectForm.get("reason").value,
            orderingProviderId: this.orderingProviderId,
            orderingProviderDisplayName: this.userDisplayName,
            signatureRequests: order.signatureRequests,
          };
          return {
            order: {},
            orderId: order.orderId,
            action: action,
          };
        })
      ),
      cancel: false,
    });
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true, shouldReload: false });
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/provider-panel/reject-selected-orders/reject-selected-orders.ts